var RENDERS;
(function (RENDERS) {
    RENDERS["ANNOUNCED_TIME"] = "VC_ANNOUNCED_TIME.render";
    RENDERS["TITLE"] = "VC_TITLE.render";
    RENDERS["FUNDING_TYPE"] = "VC_FUNDING_TYPE.render";
    RENDERS["INVESTED_IN_ORGANIZATION"] = "VC_INVESTED_IN_ORGANIZATION.render";
    RENDERS["INVESTOR_ORGANIZATION"] = "VC_INVESTOR_ORGANIZATION.render";
    RENDERS["NORMALIZED_TOPIC"] = "VC_NORMALIZED_TOPIC.render";
    RENDERS["MONEY_RAISED"] = "VC_MONEY_RAISED.render";
})(RENDERS || (RENDERS = {}));
export const INVESTMENT_COLUMNS_MAP = {
    ANNOUNCED_TIME: {
        renderer: RENDERS.ANNOUNCED_TIME,
        width: 160,
    },
    TITLE: {
        renderer: RENDERS.TITLE,
        width: 360,
    },
    FUNDING_TYPE: {
        renderer: RENDERS.FUNDING_TYPE,
        width: 200,
    },
    INVESTED_IN_ORGANIZATION: {
        renderer: RENDERS.INVESTED_IN_ORGANIZATION,
        width: 240,
    },
    INVESTOR_ORGANIZATION: {
        renderer: RENDERS.INVESTOR_ORGANIZATION,
        width: 240,
    },
    NORMALIZED_TOPIC: {
        renderer: RENDERS.NORMALIZED_TOPIC,
        width: 400,
    },
    MONEY_RAISED: {
        renderer: RENDERS.MONEY_RAISED,
        width: 200,
    },
};
